<template>
  <div class="Comment-Menu" ref="menuRef">
    <ButtonPoints class="Comment-Menu__btn" @click="toToggleMenu"/>
    <transition name="Anim__fadeUp">
      <DropMenuComment class="Comment-Menu__dropdown" @close="toCloseMenu" :commentsPlace="props.commentsPlace" :commentId="props.commentId" v-if="isOpen"/>
    </transition>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------------------------
  import DropMenuComment from '@features/DropMenu/modules/DropMenuComment/DropMenuComment.vue';
  import ButtonPoints from '@ui/Buttons/ButtonPoints/ButtonPoints.vue';
  //--------------------------------------------
  const props = defineProps(Props());
  const isOpen = ref(false);
  const menuRef = ref(null);
  //--------------------------------------------
  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
  //--------------------------------------------
  //Отобразить/скрыть меню
  const toToggleMenu = () => isOpen.value = !isOpen.value;
  //Скрыть меню
  const toCloseMenu = () => isOpen.value = false;
  //Закрыть меню, если клик вне области меню
  const handleClickOutside = (event) => {
    if(menuRef.value && !menuRef.value.contains(event.target)) {
      toCloseMenu()
    }
  };
</script>

<style lang="scss">
  @import './styles/_styles';
</style>